import React from 'react';
import { OrderType } from 'models/order.model';
import { ENUM_LIVE_CARD_MENU } from '../menu-config';
import BaseLiveTripCardHeader from './base-live-trip-card-header';
import BaseLiveTripCardBody from './base-live-trip-card-body';
import BaseLiveTripCardFooter from './base-live-trip-card-footer';
import '../styles.scss';

type Props = {
  order: OrderType;
  ridersAvailable: boolean;
  onSelectMenu: (menuKey: ENUM_LIVE_CARD_MENU) => void;
  onClick: () => void;
};

const BaseLiveTripCard = ({ order, ridersAvailable, onSelectMenu, onClick }: Props) => {
  return (
    <div role='button' onClick={onClick} className='cursor-pointer live-trip-card relative'>
      <BaseLiveTripCardHeader
        order={order}
        ridersAvailable={ridersAvailable}
        onSelectMenu={onSelectMenu}
      />
      <BaseLiveTripCardBody order={order} />
      <BaseLiveTripCardFooter order={order} />
    </div>
  );
};

export default BaseLiveTripCard;
